import * as accounts from './accounts';
import * as commons from './commons';
import * as developers from './developers';
import * as transactions from './transactions';
import * as wallets from './wallets';

export const constants: { [key: string]: any } = {
  ...accounts,
  ...commons,
  ...developers,
  ...transactions,
  ...wallets
};

export * from './accounts';
export * from './commons';
export * from './developers';
export * from './transactions';
export * from './wallets';
